export default class {
    getDefaultConfig () {
        return {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
                { name: 'links', items: ['Link', 'Unlink'] }
            ],
            removeButtons: 'Cut,Copy,Paste,Undo,Redo,Anchor,About'
        };
    }

    getMinimalisticConfig () {
        return {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] }
            ],
            removeButtons: 'Cut,Copy,Paste,Undo,Redo,Anchor,About'
        };
    }

    getTemplateTaskConfig () {
        return {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
                { name: 'links', items: ['Link', 'Unlink'] }
            ],
            removeButtons: 'Cut,Copy,Paste,Undo,Redo,Anchor,About'
        };
    }

    getNotificationConfig () {
        return {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
                { name: 'links', items: ['Link', 'Unlink'] },
                { name: 'styles', items: ['Format'] },
                { name: 'colors', items: ['TextColor'] },
                { name: 'font', items: ['Font', 'FontSize'] },
                { name: 'tools', items: ['Maximize'] }
            ],
            removeButtons: 'Cut,Copy,Paste,Undo,Redo,Anchor,About'
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/services/ckEditor/index.js